module.exports = {
    PAGEINATION: process.env.NODE_ENV === 'production' ? 20 : 20,

    BASE_URL: process.env.NODE_ENV === 'production' ? 'https://fchat.vn/' : 'https://fchat.vn/',
    SOCKET_URL: process.env.NODE_ENV === 'production' ? 'https://fchatvn-amazon.salekit.com:4033' : 'https://fchatvn-amazon.salekit.com:4033',
    API_URL: process.env.NODE_ENV === 'production' ? 'https://fchat-app.salekit.com:4039/api/v1/' : 'https://fchat-app.salekit.com:4039/api/v1/',
    API_URL_CLIENT: process.env.NODE_ENV === 'production' ? 'https://fchat.vn/api_v1/' : 'https://fchat.vn/api_v1/',

    // API_URL: process.env.NODE_ENV === 'production' ? 'http://localhost:4039/api/v1/' : 'http://localhost:4039/api/v1/',
    
    //  BASE_URL: process.env.NODE_ENV === 'production' ? 'https://fchat.co/' : 'https://fchat.co/',
    //  SOCKET_URL: process.env.NODE_ENV === 'production' ? 'https://fchatco-amazon.salekit.com:4037/' : 'https://fchatco-amazon.salekit.com:4037/',
    //  API_URL: process.env.NODE_ENV === 'production' ? 'https://fchatco-app.salekit.com:4038/api/v1/' : 'https://fchatco-app.salekit.com:4038/api/v1/',
    //  API_URL_CLIENT: process.env.NODE_ENV === 'production' ? 'https://fchat.co/api_v1/' : 'https://fchat.co/api_v1/',

}
